import React from "react";
import "../../test/create-and-save-button/CreateAndSaveButton.css";
import { Button } from "react-bootstrap";


const UpdateAndAddButton = ({id, disabled, onClick ,children }) => {
  return (
    <button className="frame" onClick={onClick} disabled={disabled} id={id} 
    style={{ width: "103px", borderRadius: "8px", boxShadow: "-1px 1px 4.5px rgba(0, 0, 0, 0.31)" }}>
      <div className="text-wrapper">{children}</div>
    </button>
  );
};

export default UpdateAndAddButton;